import CommentView from '@ui/comments/comment-view';
import { elements } from '@ui/comments/comment-view';
import { siteModel } from 'models/SiteModel';

export default class extends CommentView {
render() {
    const model = this.model;
    const rootEl = this.rootEl;
    const isOwnComment = siteModel.get('User').isAuthorOf(model);

    this.rootEl.empty();
    this.buildContainerEl();
    this.buildAvatarView();

    this.box = $(`<div class="c-comments__box"></div>`);

    this.box.append([
        this.avatarView.getRootEl(),
        this.containerEl,
      ]);

    rootEl
      .removeClass()
      .addClass(`user-comment ${elements.deleted.substr(1)}`)
      .append(this.box);

    if (model.get('isNew')) {
      rootEl.addClass(elements.recent.substr(1));
      setTimeout(() => {
          this.getRootEl().removeClass(elements.recent.substr(1));
      }, this.recentRemoveDelay);
    }

    if (isOwnComment) {
        this.rootEl.addClass(elements.own.substr(1));
        this.buildEditView();
        rootEl.append(this.editCommentView.getRootEl());
    }

    if (model.get('parentCommentId') === null) {
        this.buildRepliesView();
    }
  }
};



// WEBPACK FOOTER //
// ./src/RMPL/CoreBundle/Resources/public/js/ui/comments/comments-views/moderation-deleted-comment-view.js